import ERROR_MESSAGE_COPIES from '@/constants/error-messages/index';
import { replacePlaceholders } from "./helper";

export function getMinMaxLengthErrorMessage(fieldScheme) {
    // When min and max length are both defined in spec
    if (fieldScheme.maxLength > 0 && fieldScheme.minLength > 0) {
        // When min and max length are equal, err msg should say about exact range spec
        if (fieldScheme.minLength === fieldScheme.maxLength) {
            return replacePlaceholders(
                ERROR_MESSAGE_COPIES.length.exactCharactersLength,
                fieldScheme.minLength,
            );
        } 
        return replacePlaceholders(
            ERROR_MESSAGE_COPIES.length.minMaxCharactersLength,
            fieldScheme.minLength,
            fieldScheme.maxLength
        );
    } 
    
    // When only max length is defined in spec 
    if (fieldScheme.maxLength > 0) {
        return replacePlaceholders(
            ERROR_MESSAGE_COPIES.length.maxLength,
            fieldScheme.maxLength
        );
    }

    // When only min length is defined in spec 
    return replacePlaceholders(
        ERROR_MESSAGE_COPIES.length.minLength,
        fieldScheme.minLength
    );
}

export function getMinMaxValueErrorMessage(fieldScheme) {
    const hasMin = fieldScheme.minimum !== undefined;
    const hasMax = fieldScheme.maximum !== undefined;
    if (hasMin && hasMax) {
        return replacePlaceholders(
            ERROR_MESSAGE_COPIES.length.minMaxNumberValue,
            fieldScheme.minimum,
            fieldScheme.maximum
        );
    }
    
    if (hasMax) {
        return replacePlaceholders(
            ERROR_MESSAGE_COPIES.length.maxValue,
            fieldScheme.maximum,
        );
    }
    
    return replacePlaceholders(
        ERROR_MESSAGE_COPIES.length.minValue,
        fieldScheme.minimum,
    );
}